import script from "./SubChamados.vue?vue&type=script&setup=true&lang=js"
export * from "./SubChamados.vue?vue&type=script&setup=true&lang=js"

import "./SubChamados.vue?vue&type=style&index=0&id=e1aa3190&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\frontendRegua\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1aa3190"]])

export default __exports__